// @flow
import React, { Component } from 'react'
import { Card, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ApiService from '../../actions/apiService';
import ReactMarkdown from 'react-markdown'

class TermsOfService extends Component {
  
  state = {
    content: 'Terms Of Service',
    isLoading: true,
  }
  
  async componentWillMount() {
    const response = await ApiService.getMethod('/pages/termsofservice');
    if (response) {
      this.setState({
        content: response,
      })
    }
    this.setState({
      isLoading: false,
    });
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledMember>
          <Card title="Terms Of Service" bordered={false}>
            {
              this.state.isLoading ? <Spin/> : <ReactMarkdown escapeHtml={false} source={this.state.content} />
            }
          </Card>
        </StyledMember>
      </StyledContent>
    )
  }
}

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/components/static/TermsOfService.js